import { MutationTree } from "vuex";
import { MasterState, SET_MASTER, SetMaster } from "./types";

export const mutations: MutationTree<MasterState> = {
  [SET_MASTER](state, input: SetMaster) {
    state.loginUser = input.loginUser;
    state.menuInfo = input.menuInfo;
  }
};
